import { FOCUSABLE } from '../../focus/const';

const $ = jQuery;

// In the end, this block of code helps to understand if the last event was caused by keyboard
let isKeyboard = false;
$(document)
	.on('click', '*', () => {
		isKeyboard = false;
	});
$(document)
	.on('keydown', '*', () => {
		isKeyboard = true;
	});
$(document)
	.on('keyup', '*', () => {
		isKeyboard = true;
	});

export default function () {
	// check if hamburger menu presents on the page
	if (!$('.mobile_menu_bar').length) {
		return;
	}
	// add observer for each mobile menu
	const forceLoadHandler = (handler) => {
		$(window)
			.on('load', () => {
				// giving one second Divi to generate mobile menus
				setTimeout(handler, 1000);
			});
	};
	const handler = () => {
		$('.et_mobile_menu')
			.each(function () {
				$(this)
					.find(FOCUSABLE)
					.on('blur', (e) => {
						// if the element loses the focus by keyboard
						// and the focus goes outside mobile menu,
						// then shift the focus to hamburger menu
						if (!$(this)
							.has(e.relatedTarget).length && isKeyboard) {
							e.preventDefault();
							$(this).parent().find('.mobile_menu_bar').click();
						}
					});
			});
	};
	forceLoadHandler(handler);
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/controllers/focus-hamburger-menu-on-closing-menu.js